import { PopUpServices } from "~/services/PopUp/callPopUp";
import type { gtagReachGoal } from "~/services/SEO/goals/createCustomGoal";
import type { UnitFileDTO } from "~/services/swagger/Api";
import { Notification } from "~/services/notifications/toast";

export const redirectByProviderName = (item: {
  providerName: string | undefined;
  utmLink: string | undefined;
  providerLink: string | undefined;
  externalUrl: string | undefined;
  source?: keyof typeof gtagReachGoal;
  images: UnitFileDTO[] | undefined;
  logoFile: string | undefined;
}) => {
  const { $i18n } = useNuxtApp();
  const t = $i18n.t;

  const normalizedProviderName = item.providerName
    ?.toLowerCase()
    ?.replace(/\s+/g, "");
  if (!normalizedProviderName) {
    const errorNotify = new Notification({
      type: "system",
      message: t("errors.emptyProvider"),
    });
    errorNotify.createNewToast();
    return;
  }

  // Resolve the destination for any provider (no whitelist): prefer the referral
  // link, then the unit's externalUrl, then the generic provider url. Use `||`
  // (not `??`) so empty strings from the backend don't shadow a real URL.
  const redirectUrl = item.utmLink || item.externalUrl || item.providerLink;

  const callPopUp = PopUpServices();

  callPopUp.callPopUp({
    componentName: "provider-provider-pop-up",
    persistent: false,
    data: {
      url: redirectUrl,
      source: item.source,
      images: item.images,
      logoFile: item.logoFile,
      providerName: item.providerName,
    },
  });
};
